import type { TJSONSchema } from "@artifact-management/json-dynamic-form";
import { useI18nContext } from "@root/utils/organisation";
import { DateInputV2 } from "@styleguide";
import { type FieldValues, type Path, type PathValue, useController } from "react-hook-form";
import type { IFormGenInputProps } from "./index";

const toDate = (value: unknown): Date | null => {
  if (typeof value !== "string" || !value) {
    return null;
  }
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const FormGenInputDate = <Schema extends TJSONSchema, T extends FieldValues>({
  control,
  uiSchemaElement,
}: IFormGenInputProps<Schema, T>) => {
  const { timeZone } = useI18nContext();
  const { field, fieldState } = useController({
    control,
    name: uiSchemaElement.scope as unknown as Path<T>,
    defaultValue: "" as PathValue<T, Path<T>>,
  });

  return (
    <DateInputV2
      label={uiSchemaElement.label}
      timeZone={timeZone}
      value={toDate(field.value)}
      onChange={(date) => field.onChange(date ? date.toISOString() : "")}
      onClear={() => field.onChange("")}
      disabled={uiSchemaElement.disabled}
      TextFieldProps={{
        size: "small",
        fullWidth: true,
        onBlur: field.onBlur,
        error: Boolean(fieldState.error),
        helperText: fieldState.error?.message,
      }}
    />
  );
};
